/* -------------------------------------------------------------------------- */
/*                            External Dependencies                           */
/* -------------------------------------------------------------------------- */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Alert } from 'react-bootstrap';
import { createStructuredSelector } from 'reselect';

/* -------------------------- Internal Dependencies ------------------------- */
import { selectAlertItems } from '../../redux/alert/selector';
import { removeAlert } from '../../redux/alert/actions';

/* --------------------------- Image Dependencies --------------------------- */
import { ReactComponent as ErrorComponent } from 'assets/icons/error.svg';
import { ReactComponent as SuccessComponent } from 'assets/icons/success.svg';

/* ---------------------------- Alerts PropTypes ---------------------------- */
const proptypes = {
	alerts: PropTypes.array,
	removeAlert: PropTypes.func,
};

const Alerts = ({ alerts, removeAlert: removeAlertById }) => (
	<AlertContainer data-testid="alerts">
		{alerts !== null &&
			alerts.length > 0 &&
			alerts.map((alert) => (
				<Alert
					variant={`${alert?.alertType === 'error' ? 'danger' : 'success'}`}
					key={alert?.id}
				>
					<button onClick={() => removeAlertById?.(alert?.id)} type="button">
						&#10005;
					</button>
					<p className="alert--flex d-flex align-items-center">
						{alert.alertType === 'success' ? (
							<SuccessComponent />
						) : (
							<ErrorComponent />
						)}
						<span>{alert.msg} </span>
					</p>
				</Alert>
			))}
	</AlertContainer>
);

const AlertContainer = styled(Alert)`
	position: fixed;
	top: 1px;
	z-index: 999999;
	width: 340px;
	right: 4px;
	word-break: break-word;
	animation: fadeIn;
	animation-duration: 1s;
	animation-iteration-count: 1;

	@keyframes fadeIn {
		0% {
			opacity: 0.2;
			-webkit-transform: translateX(100%);
			transform: translateX(100%);
		}
		100% {
			opacity: 1;
			-webkit-transform: translateX(0%);
			transform: translateX(0%);
		}
	}
	span {
		&:first-letter {
			text-transform: uppercase;
		}
		text-transform: lowercase;
	}
	.h4 {
		font-size: 20px;
		font-family: blorado;
		text-transform: capitalize;
		font-weight: 800;
		color: #fff;
		margin: 0 0 8px;
	}

	button {
		position: absolute;
		right: 16px;
		border: none;
		background: transparent;
		font-size: 16px;
		color: #fff;
		cursor: pointer;
		z-index: 9999;
	}
	p {
		font-size: 14px;
		color: #fff;
		margin: 0;
	}

	.alert-success {
		width: 100%;
		padding: 13px 37px 13px 44px;
		background: #4868f8;
		border: none;
		border-radius: 3px;
		margin-left: auto;
		svg {
			width: 23px;
			margin-right: 8px;
			fill: #b7c3fb;
			position: absolute;
			left: 13px;
		}
	}
	.alert-danger {
		width: 100%;
		padding: 13px 37px 13px 44px;
		background: #da4a3f;
		border-radius: 3px;
		border: none;
		margin-left: auto;
		svg {
			width: 23px;
			margin-right: 8px;
			fill: #fdc2c2;
			position: absolute;
			left: 13px;
		}
	}
`;

const mapStateToProps = createStructuredSelector({
	alerts: selectAlertItems,
});

const mapDispatchToProps = (dispatch) => ({
	removeAlert: (id) => dispatch(removeAlert(id)),
});

Alerts.propTypes = proptypes;

export default connect(mapStateToProps, mapDispatchToProps)(Alerts);
